export default __webpack_public_path__ + "static/media/location.45e7d5c4.png";